import { takeLatest, call, put } from "redux-saga/effects"
import axios from "axios"
import { 
    FETCH_EXERNAL_LOADS_FOR_LOAD,
    SET_EXTERNAL_LOADS
} from '../actionTypes'
import moment from 'moment'

const EXTERNAL_LOADS_ORIGIN_RADIUS = 150
const EXTERNAL_LOADS_DESTINATION_RADIUS = 150

function fetchExternalLoadsWithFilter(args) {
    const request = {
        method: 'get',
        url: '/api/dat_loads'
    }

    request.params = {}

    for (let key in args) {
        if (args[key]) {
            request.params[key] = args[key]
        }
    }

    return axios(request) || []
}

function* workerFetchExternalLoadsForLoadSaga(action) {
    let {load} = action

    try {
        let searchQuery = {
            equipmentType: load.equipment_type.name,
            origin_lat: load.origin_lat,
            origin_lng: load.origin_lng,
            originRadius: EXTERNAL_LOADS_ORIGIN_RADIUS,
            dateAvailEarliest: moment(load.pickup_date).format('YYYY-MM-DD'),  // Only this is used by Otter & Hippo as of 2023-12-14
            dateAvailLatest: moment(load.pickup_date).add(1,'days').format('YYYY-MM-DD')  // This is ignored by Otter & Hippo as of 2023-12-14
        }


        searchQuery.destination_lat = load.destination_lat
        searchQuery.destination_lng = load.destination_lng
        searchQuery.destRadius = EXTERNAL_LOADS_DESTINATION_RADIUS
        searchQuery.dateAvail = load.pickup_date
        searchQuery.includeMarket = true
    
        // Wipe out table before re-rendering, so loading indicator does not interfere with table animation
        yield put({ type: SET_EXTERNAL_LOADS, loads: null })
        
        const response = yield call(fetchExternalLoadsWithFilter, searchQuery)
        
        if (response) {
            //console.log('ext loads resp', response?.data)
            //hippo returns {data: []} and otter returns just []
            // so, this handles both
            const loads = (response?.data?.data) ? response?.data?.data : response?.data

            if (loads?.length) {
                yield put({ type: SET_EXTERNAL_LOADS, loads:loads })
            } else {
                yield put({ type: SET_EXTERNAL_LOADS, loads: [] })
            }
        }
    } catch (error) {
        console.log('workerFetchExternalLoadsWithFilterSaga error: ', error)
    }
}



export function* watchFetchExternalLoadsForLoadSaga() {
    yield takeLatest(FETCH_EXERNAL_LOADS_FOR_LOAD, workerFetchExternalLoadsForLoadSaga)
}